var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-scroll-month-selector" }, [
    _c(
      "div",
      { ref: "header", staticClass: "booking-header-extension" },
      [
        _c("header-close", { attrs: { back: _vm.close } }),
        _vm._v(" "),
        _c("div", { staticClass: "booking-header-title" }, [
          _vm._v("\n      " + _vm._s(_vm.tc("booking.selectMonth")) + "\n    "),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "calendar-scroll-month-list",
        style: [
          { height: _vm.scrollHeight ? _vm.scrollHeight + "px" : "auto" },
        ],
      },
      [
        _c(
          "ul",
          { staticClass: "form" },
          _vm._l(_vm.monthsRendered, function (month) {
            return _c(
              "li",
              {
                key: "" + month.month,
                staticClass: "option",
                class: {
                  "is-hidden": _vm.isHidden(_vm.getMonthFormat(month.month)),
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedMonth,
                      expression: "selectedMonth",
                    },
                  ],
                  key: _vm.getMonthFormat(month.month),
                  attrs: {
                    id: "input-" + month.month,
                    type: "radio",
                    name: "selectedMonth",
                    disabled: _vm.isDisabled(_vm.getMonthFormat(month.month)),
                  },
                  domProps: {
                    value: _vm.getMonthFormat(month.month),
                    checked: _vm.getMonthFormat(month.month),
                    checked: _vm._q(
                      _vm.selectedMonth,
                      _vm.getMonthFormat(month.month)
                    ),
                  },
                  on: {
                    change: function ($event) {
                      _vm.selectedMonth = _vm.getMonthFormat(month.month)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    class: [
                      {
                        disabled: _vm.isDisabled(
                          _vm.getMonthFormat(month.month)
                        ),
                      },
                    ],
                    attrs: {
                      for: "input-" + month.month,
                      tabindex: _vm.isDisabled(_vm.getMonthFormat(month.month))
                        ? "-1"
                        : "0",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.handleClick(month.month)
                      },
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.handleClick(month.month)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.handleClick(month.month)
                        },
                      ],
                    },
                  },
                  [
                    _c("div", { staticClass: "month-button-container" }, [
                      _c("span", { staticClass: "label-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.tc(
                              "calendar.months." +
                                parseInt(month.month.slice(0, 2), 10)
                            )
                          ) +
                            " " +
                            _vm._s(month.month.split("-")[1])
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "icon-checkmark" }),
                    ]),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }